/*
 * @Author: 黄浩
 * @Date: 2021-08-05 19:33:03
 * @LastEditTime: 2021-08-11 14:33:01
 * @LastEditors: Please set LastEditors
 * @Descripttion: 
 * @FilePath: \dhr_frontend\src\routes\modules\mutualHelp.js
 */
export default [
    {
        name: 'basics',
        path: '/mutualHelp/basics',
        component: () => import('@/views/mutualHelp/basics.vue'),
        meta: {
            title: '基础配置'
        }
    },
    {
        name: 'projectList',
        path: '/mutualHelp/projectList',
        component: () => import('@/views/mutualHelp/project/list.vue'),
        meta: {
            title: '项目列表'
        },
    },
    {
        name: 'projectDetail',
        path: '/mutualHelp/projectDetail',
        component: () => import('@/views/mutualHelp/project/detail.vue'),
        meta: {
            parentAuth: '/mutualHelp/projectList',
            title: '项目详情'
        }
    },
    {
        name: 'mutualAidList',
        path: '/mutualHelp/mutualAidList',
        component: () => import('@/views/mutualHelp/mutualAidList.vue'),
        meta: {
          title: '互助名单'
        }
    }
]
  